export interface AutoAcceptConceptGroupData {
  conceptGroupId: string;
  conceptGroupName: string;
  filterKey: string;
}

export type AutoAcceptConceptGroupFn = (data: AutoAcceptConceptGroupData) => void;

/**
 * Module-level registry for the auto-accept callback.
 *
 * Registered by CohortVersionLayout (in feature-cohort-builder) on mount,
 * consumed by useConceptGroupEventHandling (in feature-concept-groups-list)
 * at dialog-close time.
 *
 * Using a module-level singleton rather than React Context because the producer
 * (cohort builder page) and consumer (RA chat panel) are siblings in the
 * component tree, not parent-child.
 */
let registeredAutoAccept: AutoAcceptConceptGroupFn | null = null;

export const registerAutoAcceptConceptGroup = (fn: AutoAcceptConceptGroupFn | null) => {
  registeredAutoAccept = fn;
};

export const getAutoAcceptConceptGroup = (): AutoAcceptConceptGroupFn | null => {
  return registeredAutoAccept;
};
